import { Component, Inject, Vue } from 'vue-property-decorator';
import { AxiosInstance, AxiosResponse } from 'axios';

@Component
export default class ResendConfirmEmailMixin extends Vue {
  @Inject() $api: AxiosInstance;

  async resendConfirmEmail() {
    const { profile } = this.$store.state.user;
    if (profile) {
      return await this.$api.post<AxiosResponse<any>>('profile/verification/request', { data: { id: profile.id }});
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/resendConfirmEmail.ts